import Cookies from 'js-cookie'
import cookieConstants from 'cookies.yml'
import store from 'base/store'
import { getCountryCode } from 'base/lib/localization'

export const bootstrapHelpers = {
  getCanShowHolidayShippingPromo: () => {
    return store.getState().appConfig.canShowHolidayShippingPromo
  },

  getHolidayEligibleZipCodes: () => {
    return store.getState().appConfig.eligibleHolidayZipCodes
  },
}

export function canRenderReferralBanner() {
  return !!(
    store.getState().session.visitor.latestReferral &&
    !store.getState().session.user &&
    !Cookies.get(cookieConstants.EVERLANE_USER)
  )
}

export function canRenderOutOfMarketInternationalBanner(internationalShippingCountries) {
  return !Object.keys(internationalShippingCountries).includes(getCountryCode())
}

const SWITCH_USER_BANNER_HEIGHT = 51
const DESKTOP_HEIGHT = 45
let MOBILE_HEIGHT = 40

export { MOBILE_HEIGHT, DESKTOP_HEIGHT, SWITCH_USER_BANNER_HEIGHT }
